"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.outside = exports.ltr = exports.gtr = exports.intersects = exports.minSatisfying = exports.maxSatisfying = exports.satisfies = exports.validRange = void 0;
const semver_1 = require("./go/semver");
const comparison_1 = require("./comparison");
class InvalidRequirementPart extends Error {
}
class InvalidVersionRange extends Error {
}
const DEFAULT_REQUIREMENT = [
    { startVersion: 'v0.0.0', isStartInclusive: true, isEndInclusive: false },
];
const OPS = ['>=', '<=', '>', '<', '='];
const OPS_RE = `^(${OPS.join('|')})?(.*)$`;
function parsePart(part) {
    const match = part.trim().match(OPS_RE);
    if (!match) {
        throw new InvalidRequirementPart();
    }
    const op = (match[1] || '=');
    const version = match[2].trim();
    if (!(0, semver_1.isValid)(version)) {
        throw new InvalidRequirementPart();
    }
    return { op, version };
}
function parseRange(rangeStr) {
    let parts;
    try {
        parts = rangeStr.split(',').map(parsePart);
    }
    catch (error) {
        if (error instanceof InvalidRequirementPart) {
            throw new InvalidVersionRange();
        }
        throw error;
    }
    const range = {};
    function setInclusive(attr, value) {
        if (range.hasOwnProperty(attr)) {
            throw new InvalidRequirementPart();
        }
        range[attr] = value;
    }
    function setVersion(attr, value) {
        if (range.hasOwnProperty(attr)) {
            throw new InvalidRequirementPart();
        }
        range[attr] = value;
    }
    for (const { op, version } of parts) {
        if (op === '=') {
            setVersion('startVersion', version);
            setInclusive('isStartInclusive', true);
            setVersion('endVersion', version);
            setInclusive('isEndInclusive', true);
        }
        else {
            setVersion(op[0] === '>' ? 'startVersion' : 'endVersion', version);
            setInclusive(op[0] === '>' ? 'isStartInclusive' : 'isEndInclusive', op.endsWith('='));
        }
    }
    if (range.startVersion && range.endVersion) {
        const comp = (0, comparison_1.compare)(range.startVersion, range.endVersion);
        if (comp === 1 ||
            (comp === 0 && !(range.isStartInclusive && range.isEndInclusive))) {
            throw new InvalidRequirementPart();
        }
    }
    return range;
}
function parseRequirement(requirementStr) {
    const rangeStrs = requirementStr.split('||').map((part) => part.trim());
    if (rangeStrs.length === 0) {
        return DEFAULT_REQUIREMENT;
    }
    return rangeStrs.map(parseRange);
}
function validRange(range) {
    if (!range.trim()) {
        return null;
    }
    try {
        return parseRequirement(range)
            .map((range) => {
            const parts = [];
            if (range.startVersion && range.startVersion == range.endVersion) {
                return '=' + range.startVersion;
            }
            if (range.startVersion) {
                parts.push((range.isStartInclusive ? '>=' : '>') + range.startVersion);
            }
            if (range.endVersion) {
                parts.push((range.isEndInclusive ? '<=' : '<') + range.endVersion);
            }
            return parts.length > 0 ? parts.join(',') : '>=v0.0.0';
        })
            .join(' || ');
    }
    catch (err) {
        return null;
    }
}
exports.validRange = validRange;
function satisfies(version, range) {
    // Throw an exception if the version is invalid.
    (0, semver_1.parse)(version);
    for (const part of parseRequirement(range)) {
        if (part.startVersion) {
            const comp = (0, comparison_1.compare)(version, part.startVersion);
            if (comp === -1 || (comp === 0 && !part.isStartInclusive)) {
                continue;
            }
        }
        if (part.endVersion) {
            const comp = (0, comparison_1.compare)(version, part.endVersion);
            if (comp === 1 || (comp === 0 && !part.isEndInclusive)) {
                continue;
            }
        }
        return true;
    }
    return false;
}
exports.satisfies = satisfies;
function maxSatisfying() {
    throw new Error('Not implemented');
}
exports.maxSatisfying = maxSatisfying;
function minSatisfying() {
    throw new Error('Not implemented');
}
exports.minSatisfying = minSatisfying;
function intersects(r1, r2) {
    const leftRanges = parseRequirement(r1);
    const rightRanges = parseRequirement(r2);
    for (const leftRange of leftRanges) {
        for (const rightRange of rightRanges) {
            if (!(isBefore(leftRange, rightRange) || isBefore(rightRange, leftRange))) {
                return true;
            }
        }
    }
    return false;
}
exports.intersects = intersects;
function isBefore(leftRange, rightRange) {
    if (leftRange.endVersion && rightRange.startVersion) {
        const comp = (0, comparison_1.compare)(leftRange.endVersion, rightRange.startVersion);
        if (comp === -1 ||
            (comp === 0 && !(leftRange.isEndInclusive && rightRange.isStartInclusive))) {
            return true;
        }
    }
    return false;
}
function gtr() {
    throw new Error('Not implemented');
}
exports.gtr = gtr;
function ltr() {
    throw new Error('Not implemented');
}
exports.ltr = ltr;
function outside() {
    throw new Error('Not implemented');
}
exports.outside = outside;
//# sourceMappingURL=ranges.js.map